import { Card, Col, Label, OutlineButton, PrimaryButton, ReactSelectBox, Row, SofturaTable, Tooltip } from "client/CommonComponents";
import { MultiSelect } from '@softura/customcomponent'
import './AssetInventoryReadiness.scss';
import CompleteConfirmationPopup from "client/CommonComponents/DialogBox/CompleteConfirmationPopup";

const AssetInventoryReadiness = (props?: any) => {
    const {
        regionDropDownTemp,
        handleChangeRegion,
        marketDropDownTemp,
        selectedRegion,
        selectedMarket,
        handleChangeMarket,
        fetchAction,
        showGrid,
        pagesCount,
        gridData,
        columns,
        serverTotal,
        costCenterDropDownTemp,
        handleCostCenterOnChange,
        selectedSearchedCostCenter,
        handleSearchClick,
        hideDialog,
        popupContent,
        handleClearClick,
        isLoading,
        auditCycleRange
    } = props

    const getValues = (selectedSearchedCostCenter: any) => {
        let val = ""
        if (selectedSearchedCostCenter?.length) {
            selectedSearchedCostCenter?.map((item: any) => {
                if (val == '') {
                    val = item?.label
                } else {
                    val = val + ", " + item?.label
                }
            })
        }
        return val
    }

    return (
        <>
            <div className="AssetInventoryReadinessWorkbookScreen">
                <Card data-attribute="AssetInventoryReadiness_Default_Card">
                    <div className='create-new-order-container'>
                        <div className='grid-block pt-2'>
                            <div className='mb-1 top-section'>
                                <div className='clearfix mt-sm-2 mb-3'>
                                    <div className='pull-left searchblock'>
                                        <p className='assesst-question-head searchedCostCenter'>Asset Inventory Readiness Workbook</p>
                                    </div>
                                </div>
                            </div>

                            <div className="auditCycle-container">
                                <Tooltip content= {auditCycleRange}  data-attribute="AssetInventoryReadiness_Default_Tooltip">
                                    <label className="auditCycleLabel">Audit Cycle Range : </label>
                                    <span className="dateContent">{auditCycleRange}</span>
                                </Tooltip>
                            </div>

                            <Row>
                                <Col xs={12} sm={12} md={6} lg={6} className="tooltip-description mb-2">
                                    <Tooltip content={selectedRegion ? selectedRegion?.label : null} data-attribute="AssetInventoryReadiness_Default_Tooltip_2">
                                        <label className="label">Region</label>
                                        <ReactSelectBox
                                            placeholder='Select Region'
                                            options={regionDropDownTemp}
                                            onChange={(value: any) => handleChangeRegion(value)}
                                            value={selectedRegion}
                                            isSearchable={true}
                                            className='mb-2 cost-centerDD'
                                         data-attribute="AssetInventoryReadiness_Default_SearchSelectBox" />
                                    </Tooltip>
                                </Col>
                                <Col xs={12} sm={12} md={6} lg={6} className="tooltip-description mb-2">
                                    <Tooltip content={selectedMarket ? selectedMarket?.label : null} data-attribute="AssetInventoryReadiness_Default_Tooltip_3">
                                        <label className="label">Market</label>
                                        <ReactSelectBox
                                            placeholder='Select Market'
                                            options= {selectedRegion ? marketDropDownTemp : [] }
                                            onChange={(value: any) => handleChangeMarket(value, 'searchedCostCenter')}
                                            value={selectedMarket}
                                            isSearchable={true}
                                            className='mb-2 cost-centerDD'
                                         data-attribute="AssetInventoryReadiness_Default_SearchSelectBox_2" />
                                    </Tooltip>
                                </Col>

                                <Col xs={12} sm={12} md={6} lg={6} className="tooltip-description rediness_Cost_Center mb-2">
                                    <label className="label">Cost Center</label>
                                    <Tooltip content={selectedSearchedCostCenter ? getValues(selectedSearchedCostCenter) : ''} data-attribute="AssetInventoryReadiness_Default_Tooltip_4">
                                        <MultiSelect
                                            name='searchCostCenter'
                                            value={selectedSearchedCostCenter || []}
                                            onChange={(value: any) => handleCostCenterOnChange(value)}
                                            options={selectedMarket ? costCenterDropDownTemp : []}
                                            className='mb-2 cost-centerDD'
                                            closeOnChangedValue={false}
                                            isclearable={false}
                                        />
                                    </Tooltip>
                                </Col>
                                <Col xs={12} sm={12} md={6} lg={6}>
                                    <div className="AssetButtons mt-sm-4 pt-sm-2 mb-3 mb-sm-0">
                                        <div className="clearfix AssetButtonsRgt search_clear_btn">
                                            <OutlineButton
                                                text='Clear Filters'
                                                className='me-2 pull-left'
                                                onClick={handleClearClick}
                                                disabled={selectedSearchedCostCenter?.length == 0}
                                             data-attribute="AssetInventoryReadiness_Default_Button" />
                                            <div className="search-button-align">
                                                <div className="clear_filters_btn">
                                                    <PrimaryButton
                                                        text='Search'
                                                        onClick={(e: any) => { handleSearchClick(e) }}
                                                        disabled={selectedSearchedCostCenter?.length == 0}
                                                     data-attribute="AssetInventoryReadiness_Default_Button_2" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            {showGrid ?
                                <div className={`pe-0 ${gridData?.length != 0 ? "softura-table" : "softura-table paginationNav"}`}>
                                    <SofturaTable
                                        data={gridData ?? []}
                                        columns={columns}
                                        sort={true}
                                        defaultPageSize={10}
                                        pageSizes={[10, 20, 50]}
                                        globalSearch={false}
                                        className={`order-listing-grid`}
                                        serverTotal={serverTotal}
                                        fetchAction={fetchAction}
                                        isServerSide={true}
                                        pagesCount={pagesCount}
                                        defaultPaginationPosition='Both'
                                        fixedHeader={true}
                                        loading={isLoading}
                                     data-attribute="AssetInventoryReadiness_Default_Grid" />
                                </div>
                                : null}

                        </div>
                    </div>
                </Card>
                <CompleteConfirmationPopup
                    hideDialog={hideDialog}
                    onDismiss={popupContent?.popupOutlinebtnOnclick}
                    Popupcontent={popupContent}
                    popupOutlinebtnOnclick={popupContent?.popupOutlinebtnOnclick}
                    popupPrimarybtnOnclick={popupContent?.popupPrimarybtnOnclick}
                />
            </div>
        </>
    )

}

export default AssetInventoryReadiness;